/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemDependencySchema = z.object({
  dependencyItemId: z.int(),
  dependencyType: z.enum(['SUCCESSOR', 'PREDECESSOR']),
  inherited: z.boolean().nullish(),
  inheritedFromItemId: z.int().nullish(),
});
